/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Tabs({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M10.4 2a.6.6 0 0 1 .6-.6h3A1.6 1.6 0 0 1 15.6 3v9a2.6 2.6 0 0 1-2.6 2.6H3A2.6 2.6 0 0 1 .4 12V3A1.6 1.6 0 0 1 2 1.4h4.614a2.6 2.6 0 0 1 2.434 1.687l.77 2.053a.4.4 0 0 0 .375.26H14c.138 0 .272.018.4.05V3a.4.4 0 0 0-.4-.4h-3a.6.6 0 0 1-.6-.6Zm4 5a.4.4 0 0 0-.4-.4h-3.807a1.6 1.6 0 0 1-1.498-1.038l-.77-2.054A1.4 1.4 0 0 0 6.614 2.6H2a.4.4 0 0 0-.4.4v2.4H6a.6.6 0 0 1 0 1.2H1.6V12A1.4 1.4 0 0 0 3 13.4h10a1.4 1.4 0 0 0 1.4-1.4V7Z" clipRule="evenodd" /></svg>;
}
;